import { Component } from 'react';
import AppVo from '../blogData/AppVo';
import { ButtonVo } from '../blogData/ButtonVo';
import { CatVo } from '../blogData/CatVo';
import AppCard2 from '../classes/AppCard2';
import { MainStorage } from '../classes/MainStorage';
import ButtonLine from '../ui/ButtonLine';
interface MyProps { callback: Function }
interface MyState { appList: AppVo[], filterID: number}
class DashScreen extends Component<MyProps, MyState>
{
    //#55efc4,#81ecec,#74b9ff,#a29bfe,#dfe6e9,#ffeaa7,#fab1a0,#ff7675,#fd79a8,#636e72
    private colors: string[] = ["#55efc4", "#fdcb6e", "#74b9ff", "#55efc4", "#fab1a0", "#ffeaa7", "#fab1a0", "#ff7675", "#fd79a8", "#636e72"];
    private ms: MainStorage = MainStorage.getInstance();

    constructor(props: MyProps) {
        super(props)
        this.state = { appList: this.ms.apps, filterID: 0 }
    }
    componentDidMount(): void {
        
       // this.getAppList();
    }
    
    getButtons() {
        //make an array of buttonVo objects based on the categories in mainStorage
        let buttonArray: ButtonVo[] = [];
        buttonArray.push(new ButtonVo("All", "light", 0));

        for (let i: number = 1; i < this.ms.cats.length; i++) {
            let cat: string = this.ms.cats[i].catName;
            let buttonVo: ButtonVo = new ButtonVo(cat, "light", this.ms.cats[i].id);
            buttonArray.push(buttonVo);
        }
        return <ButtonLine buttonArray={buttonArray} actionCallback={this.setFilter.bind(this)} selected={this.state.filterID} />
    }
    setFilter(index: number) {
        
        this.setState({ filterID: index });
    }
  
    getCards() {
        
        let appList: AppVo[] = this.state.appList.slice();
        if (this.state.filterID > 0) {
            let catID:number=this.ms.cats[this.state.filterID].id;
            //console.log(catID,this.ms.cats[this.state.filterID].catName);
            appList = appList.filter((item: AppVo) => item.catID === catID);
        }

        let cards: JSX.Element[] = [];
        for (let i = 0; i < appList.length; i++) {
            let key: string = "card" + i.toString();            
            let catVo:CatVo=this.ms.getCatVo(appList[i].catID);           
            cards.push(<AppCard2 key={key} appVo={appList[i]} color={catVo.catColor} callback={this.props.callback}></AppCard2>);            
        }
        return cards;
    }
    render() {
        //with react bootstrap create a responsizve grid of cards
        //each card will have a title and a body and an icon
        return (<div>
            <div className='bline'>{this.getButtons()}</div>
            <div className='app-scroll'>
                <div className="appcards">
                    {this.getCards()}
                </div>
            </div></div>)
    }
}
export default DashScreen;